import { h } from 'preact'
// Tell Babel to transform JSX into h() calls:
/** @jsx h */

const ToggleFilters = (props) => {

  function handleClick() {
    props.onClick()
  }

  return (
    <div class="c-projects-toggler" data-closed={props.closed}>
      <div class="c-projects-toggler__number">{props.number} projecten</div>

      <div className="c-button c-projects-toggler__button" onClick={handleClick}>
        FILTER PROJECTEN
        <svg class="c-icon c-button__icon c-button__icon--right c-projects-toggler__icon">
          <use href="#arrow-up" xlinkHref="#arrow-up"></use>
        </svg>
      </div>
    </div>
  )
}

export default ToggleFilters



// WEBPACK FOOTER //
// ./src/js/projects/components/ToggleFilters.js